import { gql, TypedDocumentNode } from "@apollo/client";

import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";
import { Policy, PolicyStackAttachment, QueryPolicyArgs } from "types/generated";

type DeletePolicyData = {
  policyDelete: Pick<Policy, "id" | "name"> | null;
};

type DeletePolicyVariables = {
  id: string;
  force?: boolean | null;
};

export const DELETE_POLICY: TypedDocumentNode<DeletePolicyData, DeletePolicyVariables> = gql`
  mutation DeletePolicy($id: ID!, $force: Boolean) {
    policyDelete(id: $id, force: $force) {
      id
      name
    }
  }
`;

export const SEARCH_POLICIES = gql`
  query SearchPolicies($input: SearchInput!) {
    searchPolicies(input: $input) {
      pageInfo {
        hasNextPage
        endCursor
        startCursor
      }
      edges {
        cursor
        node {
          id
          name
          type
          labels
          createdAt
          updatedAt
          body
          description
          plugin {
            id
            name
          }
          spaceDetails {
            id
            name
            accessLevel
          }
          hasAttachedStacks
        }
      }
    }
  }
`;

type GetPolicyAttachmentsData = {
  policy:
    | (Pick<Policy, "id" | "hasAttachedStacks"> & {
        attachedStacks: Pick<
          PolicyStackAttachment,
          "id" | "stackId" | "stackName" | "isModule"
        >[];
      })
    | null;
};

export const GET_POLICY_ATTACHMENTS: TypedDocumentNode<
  GetPolicyAttachmentsData,
  QueryPolicyArgs
> = gql`
  query GetPolicyAttachments($id: ID!) {
    policy(id: $id) {
      id
      hasAttachedStacks
      attachedStacks {
        id
        stackId
        stackName
        isModule
      }
    }
  }
`;

export const SEARCH_POLICIES_SUGGESTIONS = gql`
  query SearchPoliciesSuggestions($input: SearchSuggestionsInput!) {
    searchPoliciesSuggestions(input: $input) {
      ...SearchSuggestionsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;
